/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quantity: NonNullable<unknown> }} Admin_External_Booking_Edit_Extra_Quantity_PersonInputs */

const en_admin_external_booking_edit_extra_quantity_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */ (i) => {const quantityPlural = registry.plural("en", i?.quantity, {});
	if (quantityPlural == "one") return /** @type {LocalizedString} */ (`1 person`);
	if (quantityPlural == "other") return /** @type {LocalizedString} */ (`${i?.quantity} people`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.extra_quantity_person");
};

const de_admin_external_booking_edit_extra_quantity_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */ (i) => {const quantityPlural = registry.plural("de", i?.quantity, {});
	if (quantityPlural == "one") return /** @type {LocalizedString} */ (`1 Person`);
	if (quantityPlural == "other") return /** @type {LocalizedString} */ (`${i?.quantity} Personen`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.extra_quantity_person");
};

const es_admin_external_booking_edit_extra_quantity_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */ (i) => {const quantityPlural = registry.plural("es", i?.quantity, {});
	if (quantityPlural == "one") return /** @type {LocalizedString} */ (`1 persona`);
	if (quantityPlural == "other") return /** @type {LocalizedString} */ (`${i?.quantity} personas`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.extra_quantity_person");
};

const fr_admin_external_booking_edit_extra_quantity_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */ (i) => {const quantityPlural = registry.plural("fr", i?.quantity, {});
	if (quantityPlural == "one") return /** @type {LocalizedString} */ (`1 personne`);
	if (quantityPlural == "other") return /** @type {LocalizedString} */ (`${i?.quantity} personnes`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.extra_quantity_person");
};

const nl_admin_external_booking_edit_extra_quantity_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */ (i) => {const quantityPlural = registry.plural("nl", i?.quantity, {});
	if (quantityPlural == "one") return /** @type {LocalizedString} */ (`1 persoon`);
	if (quantityPlural == "other") return /** @type {LocalizedString} */ (`${i?.quantity} personen`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.extra_quantity_person");
};

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */
const it_admin_external_booking_edit_extra_quantity_person = en_admin_external_booking_edit_extra_quantity_person;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_extra_quantity_person = en_admin_external_booking_edit_extra_quantity_person;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */
const pl_admin_external_booking_edit_extra_quantity_person = en_admin_external_booking_edit_extra_quantity_person;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */
const hu_admin_external_booking_edit_extra_quantity_person = en_admin_external_booking_edit_extra_quantity_person;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs) => LocalizedString} */
const ro_admin_external_booking_edit_extra_quantity_person = en_admin_external_booking_edit_extra_quantity_person;

/**
* | quantityPlural | output |
* | --- | --- |
* | "one" | "1 person" |
* | "other" | "{quantity} people" |
*
* @param {Admin_External_Booking_Edit_Extra_Quantity_PersonInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_extra_quantity_person = /** @type {((inputs: Admin_External_Booking_Edit_Extra_Quantity_PersonInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Extra_Quantity_PersonInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_extra_quantity_person(inputs)
	if (locale === "de") return de_admin_external_booking_edit_extra_quantity_person(inputs)
	if (locale === "es") return es_admin_external_booking_edit_extra_quantity_person(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_extra_quantity_person(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_extra_quantity_person(inputs)
	if (locale === "it") return it_admin_external_booking_edit_extra_quantity_person(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_extra_quantity_person(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_extra_quantity_person(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_extra_quantity_person(inputs)
	return ro_admin_external_booking_edit_extra_quantity_person(inputs)
});
export { admin_external_booking_edit_extra_quantity_person as "admin.external_booking_edit.extra_quantity_person" }